/* eslint-disable @typescript-eslint/no-explicit-any */
import { redirect } from '@tanstack/react-router';

export async function requireAuth(redirectTo: string) {
  if (import.meta.env.DEV) return;

  // Load the widget script if it hasn't been loaded yet
  if (!(window as any).netlifyIdentity) {
    await new Promise<void>((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
  }

  const identity = (window as any).netlifyIdentity;

  // If this tab has no session flag, clear any stored token and force re-login.
  // sessionStorage is cleared on tab/window close but survives refreshes.
  if (!sessionStorage.getItem('admin_session')) {
    identity.logout?.();
    throw redirect({ to: '/login', search: { redirect: redirectTo } });
  }

  // Wait for the widget to restore session from localStorage.
  // If init already fired (script was previously loaded), fall back after 500ms.
  await new Promise<void>((resolve) => {
    if (identity.currentUser()) return resolve();
    const timeout = setTimeout(resolve, 500);
    identity.on('init', () => { clearTimeout(timeout); resolve(); });
  });

  if (!identity.currentUser()) {
    throw redirect({ to: '/login', search: { redirect: redirectTo } });
  }
}
